export const FileStatus = Object.freeze({
	PENDING: 'pending',
	UPLOADING: 'uploading',
	FINALIZING: 'finalizing',
	UPLOADED: 'uploaded',
	ERROR: 'error'
} as const)

export type FileStatusType = (typeof FileStatus)[keyof typeof FileStatus]

export interface FileWithState {
	id: string
	file: File
	status: FileStatusType
	errors: { group: string; errors: string[] }[]
	warnings?: { group: string; warnings: string[] }[]
	uploadResult?: any
}
